exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon__complete,.icon__receive{background-image:url(\"/assets/img/complete.svg\")}.icon__reject{background-image:url(\"/assets/img/reject.svg\")}.icon__update{background-image:url(\"/assets/img/edit.svg\")}.feedback-action__waiting{color:#ff9b1a}.feedback-action__complete,.feedback-action__receive{color:#24a148}.feedback-action__update{color:#00a1e4}.feedback-action__reject{color:#fb4b53}\n", ""]);

// exports
